// extracted by mini-css-extract-plugin
module.exports = {"upgrade-banner":"UpgradeBanner_upgrade-banner__sxG_D","upgrade-banner-text":"UpgradeBanner_upgrade-banner-text__R3qNp"};